export const createBufGeofenceVertices = (inPath) => {
    var bufPath = [];
    if (inPath && inPath.length) {
      // get the polyline path
      for (let v = 0; v < inPath.length; v++) {
        bufPath.push(inPath[v]);
      }
      // close the polyline by repeating the first point in the array
      bufPath.push(inPath[0]);
    }
    return bufPath;
  };